import NavigationMenu from './NavigationMenu'

const NavigationHeader = () => {
  return (
    <nav className="shadow-navigationHeader bg-white h-[72px] sm:h-screen sm:shadow-none sm:border-r sm:w-36 sticky top-0 z-50">
      <ul className="flex justify-around items-center text-grey sm:flex-col sm:pt-2">
        <NavigationMenu name="Home" />
        <NavigationMenu name="Leaderboard" />
        <NavigationMenu name="Settings" />
      </ul>
    </nav>
  )
}

export default NavigationHeader
